// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./js/flashScreen/index.less
// module id = 631
// module chunks = 9